import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=3979ac96&scoped=true"
import script from "./BasePopup.vue?vue&type=script&lang=js"
export * from "./BasePopup.vue?vue&type=script&lang=js"
import style0 from "./BasePopup.vue?vue&type=style&index=0&id=3979ac96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979ac96",
  null
  
)

export default component.exports